import { NextImage } from '@zurich-framework/nextapp/components';
import { useBasePath, useTranslation } from '@zurich/common/hooks';
import { Stack, Typography } from '@zurich/ui/atoms';
import { Link } from '@zurich/ui/legacy/components';
import { styled } from '@zurich/ui/legacy/utils';
import { RecommendedBrowserNotice } from '~/components/RecommendedBrowserNotice';

export function Welcome() {
  const { t } = useTranslation();
  const { withBasePath } = useBasePath();

  return (
    <>
      <RecommendedBrowserNotice />
      <StackStyled>
        {/* TODO: the image should not be passed to the div. Instead, use NextImage
      a styled overlay. */}
        <DivCurvedStyled
          image={withBasePath('/images/vsga/frau-mit-handy.jpg')}
        >
          <Stack alignItems="center">
            <StackLogoStyled>
              <NextImage
                width={110}
                height={24}
                src="/images/vsga/logo-full-white.svg"
                alt="logo"
              />
            </StackLogoStyled>
          </Stack>
        </DivCurvedStyled>
        <StyledCardContainer>
          <Typography variant="h2" color="white">
            {t('vsga:welcome.title')}
          </Typography>

          <Typography variant="body1 regular" color="white">
            {t('vsga:welcome.body')}
          </Typography>
          <Stack width="100%" rowGap={1}>
            <Link
              iconVariant="redirect"
              href={t('common:footer.links.legal_notice.link')}
              target="_blank"
              white
            >
              {t('common:footer.links.legal_notice.title')}
            </Link>
            <Link
              iconVariant="redirect"
              href={t('common:footer.links.data_protection.link')}
              target="_blank"
              white
            >
              {t('common:footer.links.data_protection.title')}
            </Link>
            <Link
              iconVariant="redirect"
              href={t('common:footer.links.impress.link')}
              target="_blank"
              white
            >
              {t('common:footer.links.impress.title')}
            </Link>
          </Stack>
        </StyledCardContainer>
      </StackStyled>
    </>
  );
}

const StackStyled = styled(Stack)(({ theme }) => ({
  zIndex: '100',
  marginTop: '-80px',
  height: '100vh',
  backgroundColor: theme.palette.primary.main,
  overflowX: 'hidden',
}));

const StackLogoStyled = styled(Stack)(({ theme }) => ({
  width: '100vw',
  flexDirection: 'row',
  justifyContent: 'flex-end',
  padding: theme.spacing(1),
}));

const DivCurvedStyled = styled('div')<{ image?: string }>(({ image }) => ({
  backgroundSize: '100% auto',
  backgroundRepeat: 'no-repeat',
  backgroundPosition: 'center center',
  backgroundImage: `url("${image}")`,
  marginLeft: 'calc((100vw / 2 ) - (600px / 2))',
  height: '40%',
  width: '600px',
  borderRadius: '0% 0% 38% 61% / 0% 0% 40% 84%',
}));

const StyledCardContainer = styled(Stack)(({ theme }) => ({
  padding: theme.spacing(5),
  alignItems: 'center',
  rowGap: theme.spacing(4),
}));
